module.exports = __webpack_public_path__ + "img/dx.0a5f3dbd.png";